import '@here/oidcha-sdk'

import { config } from '../../../lib/config'
import { createNonce, isNonceValid, parseNonce, removeNonce, storeNonce } from './utils'

const options: HERE.OIDC.Options = {
  clientId: config.HA_CLIENT_ID,
  currentWindow: window.location.origin,
  environment: config.HA_URL,
  nonce: String(new Date().getTime()),
  realm: 'here',
  redirectUri: `${window.location.origin}/sign-in`,
  responseType: 'id_token token',
  scope: 'openid profile email phone',
  signInScreenConfig: ['facebook', 'password'],
}

const SIGN_OUT_URL = config.HA_URL + '/clearCookies'

export function signUp(state: string): void {
  createNonce()
    .then((nonce) => {
      storeNonce(nonce)
      window.here.Account.Openid({
        ...options,
        nonce,
        onlySignUp: false,
        openSignUp: true,
        state,
      }).oidcAuthorize()
    })
    .catch((error) => console.error(error))
}

export function signIn(state: string, prompt: 'login' | 'none' = 'login'): void {
  createNonce()
    .then((nonce) => {
      storeNonce(nonce)
      window.here.Account.Openid({
        ...options,
        nonce,
        openSignUp: false,
        prompt,
        state,
      }).oidcAuthorize()
    })
    .catch((_) => null)
}

export function hasValidNonce(idToken: string): boolean {
  const nonce = parseNonce(idToken)
  const isValid = isNonceValid(nonce)
  removeNonce()

  return isValid
}

export function signOut(token?: string): Promise<void> {
  if (token === undefined) {
    return Promise.resolve()
  }

  const requestInit: RequestInit = {
    body: JSON.stringify({ clearType: 'logout' }),
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
    },
    method: 'POST',
  }

  return fetch(SIGN_OUT_URL, requestInit).then(() => Promise.resolve())
}
